// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  padding-top: 24px;
  padding-bottom: 48px;
  box-sizing: border-box;
}

.catalog__nav {
  position: sticky;
  top: 90px;
  flex-shrink: 0;
}

.catalog__content {
  flex: 1;
  min-width: 0;
}

.catalog__toolbar {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.catalog__back {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #4e3f3a;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.catalog__back:hover {
  color: #df484f;
}

.catalog__back--ghost {
  opacity: 0.75;
}

.catalog__products {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-content: flex-start;
}

.catalog__products > .product-card {
  flex: 0 0 179px;
  width: 179px;
  max-width: 179px;
}

.catalog__message {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #4e3f3a;
}

.catalog__message--error {
  color: #c00;
}

.catalog__cart-open-btn {
  position: fixed;
  right: 26px;
  bottom: 24px;
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 12px 20px;
  border: 2px solid #a78c83;
  border-radius: 32px;
  background: #df484f;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  font-family: 'Roboto', sans-serif;
}

.catalog__cart-open-btn:hover {
  background: #c93d44;
}

.catalog__cart-open-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
}

.catalog__cart-open-meta {
  font-size: 14px;
  line-height: 1.2;
  opacity: 0.9;
}

.catalog__cart-modal {
  position: fixed;
  inset: 0;
  z-index: 50;
  pointer-events: none;
}

.catalog__cart-modal-backdrop {
  position: fixed;
  inset: 0;
  border: none;
  background: rgba(78, 63, 58, 0.28);
  cursor: pointer;
  pointer-events: auto;
}

.catalog__cart-modal-panel {
  position: fixed;
  right: 26px;
  bottom: 96px;
  z-index: 51;
  width: auto;
  max-width: min(400px, calc(100vw - 32px));
  max-height: calc(100vh - 120px);
  height: auto;
  overflow: visible;
  background: transparent;
  padding: 0;
  box-shadow: none;
  pointer-events: auto;
}

.catalog__cart-modal-panel .cart {
  width: 400px;
  max-width: 100%;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
}

.catalog__cart-modal-close {
  position: absolute;
  top: -10px;
  right: -6px;
  z-index: 2;
  width: 34px;
  height: 34px;
  border: 2px solid #a78c83;
  border-radius: 50%;
  background: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #4e3f3a;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1024px) {
  .catalog {
    gap: 20px;
  }
}

@media (max-width: 820px) {
  .catalog {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding-top: 16px;
    padding-bottom: 40px;
  }

  .catalog__nav {
    position: static;
    width: 100%;
  }

  .catalog__content {
    width: 100%;
  }

  .catalog__toolbar {
    margin-bottom: 16px;
  }

  .catalog__products {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    width: 100%;
  }

  .catalog__products > .product-card {
    flex: unset;
    width: 100%;
    max-width: none;
  }

  .catalog__cart-open-btn {
    right: 16px;
    bottom: 16px;
    padding: 10px 16px;
    border-radius: 24px;
  }

  .catalog__cart-modal-panel {
    right: 16px;
    left: 16px;
    bottom: 88px;
    max-width: none;
  }

  .catalog__cart-modal-panel .cart {
    width: 100%;
    margin: 0 auto;
  }
}

@media (max-width: 430px) {
  .catalog {
    padding-top: 12px;
    padding-bottom: 32px;
  }

  .catalog__back {
    font-size: 16px;
  }

  .catalog__cart-open-title {
    font-size: 18px;
  }

  .catalog__cart-open-meta {
    font-size: 13px;
  }

  .catalog__cart-modal-panel {
    bottom: 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CatalogPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".catalog {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 24px;\n  padding-top: 24px;\n  padding-bottom: 48px;\n  box-sizing: border-box;\n}\n\n.catalog__nav {\n  position: sticky;\n  top: 90px;\n  flex-shrink: 0;\n}\n\n.catalog__content {\n  flex: 1;\n  min-width: 0;\n}\n\n.catalog__toolbar {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.catalog__back {\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  color: #4e3f3a;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.catalog__back:hover {\n  color: #df484f;\n}\n\n.catalog__back--ghost {\n  opacity: 0.75;\n}\n\n.catalog__products {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-content: flex-start;\n}\n\n.catalog__products > .product-card {\n  flex: 0 0 179px;\n  width: 179px;\n  max-width: 179px;\n}\n\n.catalog__message {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  color: #4e3f3a;\n}\n\n.catalog__message--error {\n  color: #c00;\n}\n\n.catalog__cart-open-btn {\n  position: fixed;\n  right: 26px;\n  bottom: 24px;\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 12px 20px;\n  border: 2px solid #a78c83;\n  border-radius: 32px;\n  background: #df484f;\n  color: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n  font-family: 'Roboto', sans-serif;\n}\n\n.catalog__cart-open-btn:hover {\n  background: #c93d44;\n}\n\n.catalog__cart-open-title {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.2;\n}\n\n.catalog__cart-open-meta {\n  font-size: 14px;\n  line-height: 1.2;\n  opacity: 0.9;\n}\n\n.catalog__cart-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  pointer-events: none;\n}\n\n.catalog__cart-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  border: none;\n  background: rgba(78, 63, 58, 0.28);\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.catalog__cart-modal-panel {\n  position: fixed;\n  right: 26px;\n  bottom: 96px;\n  z-index: 51;\n  width: auto;\n  max-width: min(400px, calc(100vw - 32px));\n  max-height: calc(100vh - 120px);\n  height: auto;\n  overflow: visible;\n  background: transparent;\n  padding: 0;\n  box-shadow: none;\n  pointer-events: auto;\n}\n\n.catalog__cart-modal-panel .cart {\n  width: 400px;\n  max-width: 100%;\n  max-height: calc(100vh - 140px);\n  overflow-y: auto;\n}\n\n.catalog__cart-modal-close {\n  position: absolute;\n  top: -10px;\n  right: -6px;\n  z-index: 2;\n  width: 34px;\n  height: 34px;\n  border: 2px solid #a78c83;\n  border-radius: 50%;\n  background: #fff;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  color: #4e3f3a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 1024px) {\n  .catalog {\n    gap: 20px;\n  }\n}\n\n@media (max-width: 820px) {\n  .catalog {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    padding-top: 16px;\n    padding-bottom: 40px;\n  }\n\n  .catalog__nav {\n    position: static;\n    width: 100%;\n  }\n\n  .catalog__content {\n    width: 100%;\n  }\n\n  .catalog__toolbar {\n    margin-bottom: 16px;\n  }\n\n  .catalog__products {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n    width: 100%;\n  }\n\n  .catalog__products > .product-card {\n    flex: unset;\n    width: 100%;\n    max-width: none;\n  }\n\n  .catalog__cart-open-btn {\n    right: 16px;\n    bottom: 16px;\n    padding: 10px 16px;\n    border-radius: 24px;\n  }\n\n  .catalog__cart-modal-panel {\n    right: 16px;\n    left: 16px;\n    bottom: 88px;\n    max-width: none;\n  }\n\n  .catalog__cart-modal-panel .cart {\n    width: 100%;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 430px) {\n  .catalog {\n    padding-top: 12px;\n    padding-bottom: 32px;\n  }\n\n  .catalog__back {\n    font-size: 16px;\n  }\n\n  .catalog__cart-open-title {\n    font-size: 18px;\n  }\n\n  .catalog__cart-open-meta {\n    font-size: 13px;\n  }\n\n  .catalog__cart-modal-panel {\n    bottom: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
